exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".network-right-border {\n  border-right: solid 1px #eee; }\n\n.network-text {\n  text-align: center;\n  font-size: 48px;\n  color: #007CBB;\n  margin-top: 24px; }\n\n.network-card-text {\n  padding: 36px; }\n\n.network-title {\n  text-align: center;\n  font-size: 14px;\n  margin-top: 36px; }\n\n.network-active-number {\n  color: #0094D2; }\n\n.network-disabled-number {\n  color: #6B7987; }\n\n.network-chart-numbers {\n  text-align: center;\n  font-size: 24px; }\n\n.network-chart-legend {\n  text-align: center;\n  font-size: 14px;\n  margin-top: 12px; }\n\n.networking-header h2 {\n  margin-top: 0px; }\n\ndiv.networking-card.col-lg-12 {\n  padding-left: 0px; }\n  div.networking-card.col-lg-12 .card.card-block {\n    margin-top: 12px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/modules/networking/networking-vcd/networking-vcd.scss
// module id = mpEq
// module chunks = 0